module.exports = __webpack_public_path__ + "img/keyboard_Arrow_Left_Right.afd92e11.png";